<template>
  <el-container class="regfest-service-layout" style="height: 100%;">
    <el-header class="regfest-service-layout__header">
      <div
        class="regfest-service-layout__header-burger"
        :class="{'regfest-service-layout__header-burger--opened': menuIsOpened}"
      >
        <div
          class="regfest-service-layout__header-burger-wrapper"
          @click="_onBurgerMenuClick"
        >
          <div class="regfest-service-layout__header-burger-item"/>
          <div class="regfest-service-layout__header-burger-item"/>
          <div class="regfest-service-layout__header-burger-item"/>
        </div>
      </div>
      <div class="regfest-service-layout__header-user">
        <el-dropdown trigger="click" @command="_handleUserMenuClick">
          <div class="regfest-service-layout__header-user-link">
            <span class="regfest-service-layout__header-user-link--name">{{userString}}</span>
            <el-avatar class="regfest-service-layout__header-user-avatar" size="small" icon="el-icon-user-solid"/>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">Выход</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>
    <slot/>
  </el-container>
</template>

<script>
export default {
  name: 'Layout',
  props: {
    menuIsOpened: {
      type: Boolean,
      default: false,
    },
    userData: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    userString() {
      return `${this.userData.name}`;
      //TODO сейчас приходит только имя
      //return `${this.userData.surename} ${this.userData.name.charAt(0).toUpperCase()}. ${this.userData.patronymic.charAt(0).toLocaleUpperCase()}.`;
    }
  },
  methods: {
    _handleUserMenuClick(command) {
      switch (command) {
          case "1":
            return this.$emit('logout');
      }
    },
    _onBurgerMenuClick() {
      this.$emit('burger-click')
    }
  }
};
</script>

<style lang="scss">
@import "src/app/styles/variables";

.regfest-service-layout {
  height: 100%;
  &__header {
    background: #409EFF;
    //line-height: 60px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    @media (max-width: $mq-tablet) {
      justify-content: space-between;
    }
  }
  &__header-burger {
    display: none;
    color:#ffffff;
    cursor: pointer;
    @media (max-width: $mq-tablet) {
      display: block;
    }
    &--opened {
      .regfest-service-layout__header-burger-item {
        &:first-child {
          transform: rotate(45deg) translate(2px, 12px);
        }
        &:nth-child(2) {
          opacity: 0;
        }
        &:nth-child(3) {
          transform: rotate(-45deg) translate(5px, -15px);
        }
      }
    }
  }
  &__header-burger-wrapper {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    width: 34px;
    height: 28px;
  }
  &__header-burger-item {
    width: 100%;
    height: 4px;
    background: white;
    border-radius: 3px;
    transition: all 0.3s ease-in-out;
  }
  &__header-user {
  }
  &__header-user-link {
    display: flex;
    align-items: center;
    cursor: pointer;
    color:#ffffff;
    &--name {
      @media (max-width: $mq-tablet) {
        display: none;
      }
    }
  }
  &__header-user-container {

  }
  &__header-user-avatar {
    display: none;
    @media (max-width: $mq-tablet) {
      display: inline-block;
    }
  }
}
</style>
